import React from 'react';

const FlatwareFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 2v20h3v-7h1V7c0-2.8-1.2-5-4-5zM10 6H9V2H8v4H7V2H6v8h2v4H7v8h3v-8H9v-4h2V2h-1z"
        />
    </svg>
);

FlatwareFillSvg.displayName = 'FlatwareFillSvg';
export default FlatwareFillSvg;
